import React from "react";
import { Slider, Box } from "@mui/material";

type Props = {
  value: [number, number];
  onChange: (min: number, max: number) => void;
  onCommit: () => void;
};

const FloatSlider: React.FC<Props> = ({ value, onChange, onCommit }) => {
  return (
      <Box>
        <Slider
            value={value}
            min={0}
            max={1}
            step={0.01}
            disableSwap
            onChange={(_, v) => {
              if (!Array.isArray(v)) return;
              onChange(v[0], v[1]);
            }}
            onChangeCommitted={onCommit}
            track={false}
            sx={{
              height: 8,
              "& .MuiSlider-rail": {
                height: 8,
                borderRadius: 9999,
                background:
                    "linear-gradient(to right,"
                    + "#14532d 0%, #14532d 7%,"
                    + "#22c55e 7%, #22c55e 15%,"
                    + "#eab308 15%, #eab308 38%,"
                    + "#f87171 38%, #f87171 45%,"
                    + "#b91c1c 45%, #b91c1c 100%)",
              },
              "& .MuiSlider-thumb": {
                width: 16,
                height: 16,
                backgroundColor: "#fff",
                border: "1px solid #111827",
                "&:before": { display: "none" },
              },
            }}
        />
      </Box>
  );
};

export default FloatSlider;
